import React from "react";
import styled from "styled-components";

const ba = ({ onClick, tooltip = "View" }) => {
  return (
    <StyledWrapper>
      <button className="Btn" onClick={onClick}>
        <svg
          className="svgIcon"
          xmlns="http://www.w3.org/2000/svg"
          viewBox="0 0 24 24"
        >
          <path
            d="M10.0696 7C10.3869 3.9787 11.8424 3 15.5 3C19.7059 3 21 4.29412 21 8.5C21 12.1576 20.0213 13.6131 17 13.9304M3 15.5C3 11.2941 4.29412 10 8.5 10C12.7059 10 14 11.2941 14 15.5C14 19.7059 12.7059 21 8.5 21C4.29412 21 3 19.7059 3 15.5Z"
            strokeWidth="1.5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
        <span className="tooltip">Скопировать</span>
      </button>
    </StyledWrapper>
  );
};

const StyledWrapper = styled.div`
  .Btn {
    width: 40px;
    height: 40px;
    border: none;
    border-radius: 50%;
    background-color: rgb(27, 27, 27);
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    position: relative;
    transition: 0.3s;
    box-shadow: 2px 2px 8px rgba(0, 0, 0, 0.1);
  }

  .svgIcon {
    color: rgb(214, 178, 255);
  }

  .tooltip {
    position: absolute;
    right: -90px;
    opacity: 0;
    background-color: rgb(12, 12, 12);
    color: white;
    padding: 4px 8px;
    border-radius: 4px;
    font-size: 0.8rem;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: 0.2s;
    pointer-events: none;
    letter-spacing: 0.3px;
  }

  .tooltip::before {
    position: absolute;
    content: "";
    width: 8px;
    height: 8px;
    background-color: rgb(12, 12, 12);
    transform: rotate(45deg);
    left: -4%;
    transition: 0.3s;
  }

  .Btn:hover .tooltip {
    opacity: 1;
  }

  .Btn:hover {
    background-color: rgb(150, 94, 255);
  }

  .Btn:hover .svgIcon {
    color: white;
  }
`;

export default ba;
